import React, { useEffect } from 'react';

const DISMISS_MS = 6000;

export default function UndoToast({ action, listTitle, onUndo, onClose }) {
  useEffect(() => {
    if (!action) return undefined;
    const t = setTimeout(onClose, DISMISS_MS);
    return () => clearTimeout(t);
  }, [action, onClose]);
  if (!action) return null;
  return (
    <div className="ls-toast" role="status" data-testid="list_toast">
      <span>{action.kind === 'add'
        ? `Added ${action.name}${listTitle ? ` to ${listTitle}` : ''}`
        : `Removed ${action.name}`}</span>
      <button type="button" className="ls-toast__undo" onClick={onUndo} data-testid="list_toast_undo">Undo</button>
      <button type="button" className="ls-toast__close" onClick={onClose} aria-label="Dismiss" data-testid="list_toast_close">×</button>
    </div>
  );
}
